import useSWRImmutable from 'swr/immutable'

import { useApis } from '@/legacy-src/contexts/api-context'
import useUser from '@/legacy-src/hooks/useUser'

// values from BE
enum Source {
  VOCATIVE_NOT_USED_BY_LANGUAGE,
  VERIFIED,
  BEST_EFFORT_DERIVED,
  NOMINATIVE_FALLBACK,
}

type Props = { vocative: string; source: Source }

const fetchGetVocativeName = async (api, name: string): Promise<Props> => {
  const res = await api.getVocativeName(name)
  return res.data
}

const useGetVocativeName = (name: string) => {
  const { api } = useApis()
  const { user } = useUser()

  const baseName = name || user?.firstName || ''

  const { data, isLoading } = useSWRImmutable(baseName ? ['useGetVocativeName', baseName] : null, ([, nominative]) =>
    fetchGetVocativeName(api, nominative),
  )

  return { data, isLoading, baseName }
}

export default useGetVocativeName
